import { Component, computed, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-recalculate-button',
  template: `
    <span [matTooltip]="disabledTooltip()" [matTooltipDisabled]="!isDisabled() || !disabledTooltip()">
      <button
        (click)="onRecalculate()"
        [disabled]="isDisabled()"
        color="accent"
        data-test="recalculate-button"
        mat-flat-button
      >
        @if (isLoading()) {
          <mat-icon>
            <mat-spinner diameter="24" strokeWidth="3" />
          </mat-icon>
        }
        {{ labelText() }}
      </button>
    </span>
  `,
  styles: `
    span {
      display: inline-flex;
    }

    button {
      font-size: 14px;
    }
  `,
  imports: [
    MatIcon,
    MatProgressSpinner,
    MatButton,
    MatTooltip,
  ],
})
export class RecalculateButtonComponent {
  /**
   * The label to display on the button
   */
  public readonly label = input.required<string>();

  /**
   * The label to display when the button is in a loading state (optional)
   */
  public readonly loadingLabel = input<string | null>(null);

  /**
   * Whether the button is disabled
   */
  public readonly disabled = input<boolean>(false);

  public readonly disabledTooltip = input<string>('');

  /**
   * Whether a loading spinner should be shown
   */
  public readonly isLoading = input<boolean>(false);

  /**
   * Event emitted when the button is clicked
   */
  public readonly recalculate = output<void>();

  /**
   * Computed property to determine if the button should be disabled
   */
  protected readonly isDisabled = computed(
    () => this.disabled() || this.isLoading(),
  );

  /**
   * Computed property to determine the label to display on the button
   */
  protected readonly labelText = computed(
    () => this.isLoading() && this.loadingLabel() ? this.loadingLabel() : this.label(),
  );

  protected onRecalculate(): void {
    if (!this.isDisabled()) {
      this.recalculate.emit();
    }
  }
}

